// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"120":"a2d254afc86f3501","888":"0ea7c2430b4d4225"}[chunkId] + ".css";
};